import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./ServiceRequestScheduleForm.scss";
import { ICONS } from "../../common/constants";
import Button from "../Button";
import Col from "../Col";
import Form from "../Form";
import Row from "../Row";
import { convertImgToBase64 } from "../PropertyWalkThroughForm/IndexDB";
import { fetchServiceProviders } from "../../store/actions/contacts";
import { fetchAvailableServiceTimes } from "../../store/actions/availableServiceTimes";
import { saveScheduledAppointment } from "../../store/actions/serviceRequest";
import Loader from "../Loader";
import { selectFormLoader } from "../../store/selectors/FormLoader";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { selectSuiteUsers } from "../../store/selectors/suiteUsers";
import { clearSuiteUsers } from "../../store/actions/suites";
import Icon from "../Icon";
import {
  updateServiceRequest,
  fetchServiceRequestById,
} from "../../store/actions/serviceRequest";
import { fetchServiceRequestFaqsNotesDocuments } from "../../store/actions/faqsNotesDocuments";
import Tile from "../Tile";
import CreatableSelect from "react-select/creatable";
import { fetchServiceRequestTags } from "../../store/actions/formOptions";
import { BrandingContext } from "../../branding/BrandingContextProvider";
import Textarea from "../Textarea";

class ServiceRequestEditForm extends Component {
  state = {
    formData: {},
    availableServiceTimes: [],
    issueType: "",
    issueTypeId: "",
    openCalendly: "",
    images: this.props.serviceRequest.attachment
      ? JSON.parse(this.props.serviceRequest.attachment)
      : [],
    tags: [],
  };

  componentDidMount() {
    const {
      serviceRequest,
      onFetchServiceProviders,
      onClearSuiteUsers,
      onFetchServiceRequestTags,
    } = this.props;
    onFetchServiceRequestTags();
    onClearSuiteUsers();
    let params = {
      Name: serviceRequest.issueType.name,
      id: serviceRequest.propertyId,
    };
    this.setState({
      issueType: serviceRequest.issueType.name,
      issueTypeId: serviceRequest.issueType.id,
      description: serviceRequest.description,
    });

    let selectedtags = [];
    let tags =
      serviceRequest.tags && serviceRequest.tags.length > 0
        ? serviceRequest.tags
        : [];

    if (tags && tags.length > 0) {
      tags.forEach((tag) => {
        selectedtags = [...selectedtags, { value: tag.id, label: tag.name }];
      });
    }
    this.setState({ tags: selectedtags });

    onFetchServiceProviders(params);

    this.setState({
      formData: {
        userId:
          serviceRequest.serviceProvider.id !==
          "00000000-0000-0000-0000-000000000000"
            ? serviceRequest.serviceProvider.id
            : "",
      },
    });
  }

  setFormData(e) {
    const { formData } = this.state;

    this.setState({
      formData: {
        ...formData,
        ...e,
      },
    });
  }

  setAvailableServiceTimes(contact) {
    const { onFetchAvailableServiceTimes, serviceRequest } = this.props;
    const servicePreferences = [];
    let theme = localStorage.getItem("theme");
    if (theme === "Albaster") {
      serviceRequest.preferredServiceTimes.forEach((s) => {
        s.slots.forEach((slot) => {
          if (slot === "7:30 - 11:30") {
            servicePreferences.push(s.day + ":7am-11am");
          } else if (slot === "11:30 - 3:30") {
            servicePreferences.push(s.day + ":11am-3pm");
          } else {
            servicePreferences.push(s.day + ":all day");
          }
        });
      });
      onFetchAvailableServiceTimes(contact.id, servicePreferences.join(","));
    } else {
      serviceRequest.preferredServiceTimes.forEach((s) => {
        s.slots.forEach((slot) => {
          servicePreferences.push(s.day + ":" + slot.split(" ", 1));
        });
      });
      onFetchAvailableServiceTimes(contact.id, servicePreferences.join(","));
    }
  }

  handleEventScheduled = (e) => {
    const { serviceRequest, handleSaveScheduledAppointment, onClose } =
      this.props;

    onClose();
    handleSaveScheduledAppointment(this.state.formData, serviceRequest.id);
  };

  upLoadImage = async (files) => {
    let upLoadedImages = [];
    if (files && files.length > 0) {
      for (var i = 0; i < files.length; i++) {
        let data = await convertImgToBase64(files[i]);
        upLoadedImages.push(data);
      }
      return upLoadedImages;
    }
  };

  selectMultipleItems = async (files) => {
    if (files && files.length > 0) {
      let upLoadedImages = await this.upLoadImage(files);
      this.setState({ images: [...this.state.images, upLoadedImages[0]] });
    }
  };

  updateServiceRequest = () => {
    let serviceRequestTagging = [];
    let tags = this.state.tags;
    if (tags && tags.length > 0) {
      tags.forEach((tag) => {
        if (tag.__isNew__) {
          serviceRequestTagging = [
            ...serviceRequestTagging,
            { name: tag.value },
          ];
        } else {
          serviceRequestTagging = [
            ...serviceRequestTagging,
            { id: tag.value },
          ];
        }
      })
    }
    let data = {
      id: this.props.serviceRequest.id,
      subject: this.props.serviceRequest.subject,
      description: this.state.description,
      Attachment: JSON.stringify(this.state.images).toString(),
      issueType: this.state.issueType,
      IssueTypeId: this.state.issueTypeId,
      creatorId: this.props.user.id,
      tags: serviceRequestTagging,
    };
    this.props.onUpdateServiceRequest(data, "EditServiceRequest");
  };

  handleDelete(_, index) {
    console.log(index, "index");
    let images = this.state.images;
    images.splice(index, 1);
    this.setState({
      images,
    });
  }

  onSetTags = (newValue) => {
    this.setState({
      tags: newValue,
    });
  };

  static contextType = BrandingContext;

  render() {
    const {
      onClose,
      loader,
      types,
      serviceRequestTags,
    } = this.props;
    const { tags } = this.state;
    const { branding } = this.context;

    return (
      <Form
        headline={`Edit ${branding?.text?.serviceRequest ?? "Service Request"}`}
        onClose={() => {
          onClose();
          this.setState({ formData: {}, availableServiceTimes: [] });
        }}
        onSubmit={() => {
          this.updateServiceRequest();
          onClose();
          this.setState({ formData: {}, availableServiceTimes: [] });
        }}
        actions={
          <>
            {loader ? <Loader center={true} /> : null}
            <Button
              color="semantic"
              size="small"
              label="Cancel"
              onClick={() => {
                onClose()
              }}
            />
            <Button
              color="teal"
              type="submit"
              size="small"
              label="Save Changes"
              style={{ marginLeft: "1em" }}
            />
          </>
        }
        component={
          <Row mdCenter style={{overflow: "visible"}}>
            <Col chonky xs="12" md="8" style={{ marginTop: "2em" }}>
              <Row granola>
                {types.map((issueType) => (
                  <Col granola key={issueType.name} xs="6" md="4">
                    <Tile
                      icon={
                        <Icon weight="light" glyph={ICONS[issueType.name]} />
                      }
                      active={issueType.name === this.state.issueType}
                      onClick={() =>
                        this.setState({
                          issueType: issueType.name,
                          issueTypeId: issueType.id,
                        })
                      }
                      title={
                        issueType.name === "Heating/Cooling"
                          ? "Heating / Cooling"
                          : issueType.name
                      }
                      size="tiny"
                    />
                  </Col>
                ))}
              </Row>

              <label className="textarea__label">Tags</label>
              <CreatableSelect
                placeholder="Add or create tags"
                closeMenuOnSelect={false}
                isClearable
                isMulti
                options={
                  serviceRequestTags.length > 0
                    ? serviceRequestTags.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))
                    : []
                }
                value={tags}
                onChange={(newValue, actionMeta) =>
                  this.onSetTags(newValue, actionMeta)
                }
              />

              <label className="textarea__label" style={{marginTop:'.75em'}}>Description</label>
              <Textarea
                className="textarea"
                value={this.state.description}
                onChange={(e) => this.setState({ description: e.target.value })}
              />
              
            </Col>
          </Row>
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    serviceRequest: state.serviceRequest,
    availableServiceTimes: state.availableServiceTimes,
    contacts: selectSuiteUsers(state),
    loader: selectFormLoader(state),
    user: selectAuthenticatedUser(state),
    types: state.formOptions.types,
    serviceRequestTags: state.formOptions.serviceRequestTags,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClearSuiteUsers: clearSuiteUsers,
      onFetchAvailableServiceTimes: fetchAvailableServiceTimes,
      onSaveScheduledAppointment: saveScheduledAppointment,
      onFetchServiceProviders: fetchServiceProviders,
      onUpdateServiceRequest: updateServiceRequest,
      onFetchServiceRequestById: fetchServiceRequestById,
      onFetchNotesAndDocuments: fetchServiceRequestFaqsNotesDocuments,
      onFetchServiceRequestTags: fetchServiceRequestTags,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceRequestEditForm);
